// FTEDN Creator — Router (all feature pages)
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/auth.store';
import { MainLayout } from './components/layout/MainLayout';
import { LoginPage } from './pages/Auth/LoginPage';
import { DashboardPage } from './pages/Dashboard/DashboardPage';
import { WaitlistPage } from './pages/Waitlist/WaitlistPage';
import { BetaProgramPage } from './pages/BetaProgram/BetaProgramPage';
import { ProductLabPage } from './pages/ProductLab/ProductLabPage';
import { VotingPage } from './pages/Voting/VotingPage';
import { CommunityPage } from './pages/Community/CommunityPage';
import { AlertsPage } from './pages/Alerts/AlertsPage';
import { ChatPage } from './pages/Chat/ChatPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuthStore();
  if (isLoading) return <div className="loading-screen">Loading...</div>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return <MainLayout>{children}</MainLayout>;
}

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/join" element={<LoginPage />} />
      <Route path="/waitlist" element={<WaitlistPage />} />
      <Route path="/" element={<WaitlistPage />} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/beta" element={<ProtectedRoute><BetaProgramPage /></ProtectedRoute>} />
      <Route path="/lab" element={<ProtectedRoute><ProductLabPage /></ProtectedRoute>} />
      <Route path="/vote" element={<ProtectedRoute><VotingPage /></ProtectedRoute>} />
      <Route path="/community" element={<ProtectedRoute><CommunityPage /></ProtectedRoute>} />
      <Route path="/alerts" element={<ProtectedRoute><AlertsPage /></ProtectedRoute>} />
      <Route path="/chat" element={<ProtectedRoute><ChatPage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/waitlist" replace />} />
    </Routes>
  );
}
